import { getUserEmail } from "../getUserEmail";
import type { SelectionNegotiationConfig } from "../../../models/eplex/Selection";

// Снимок настроек согласования (наценка, срок жизни ссылки, контакты, комментарий),
// заданных в wizard'е при запуске КП. Бэкенд zakooper этот объект не хранит до
// отправки /negotiate, а в памяти он теряется на перезагрузке — поэтому кладём его
// в localStorage ПО ПОЛЬЗОВАТЕЛЯМ (как цели подбора): `${BASE_KEY}.<email>`. Нужен,
// чтобы форма отправки КП предзаполнилась тем, что менеджер ввёл на шаге запуска.
const BASE_KEY = "eplex-selection-negotiations";

function getStorageKey(): string {
  const email = getUserEmail();
  return email ? `${BASE_KEY}.${email}` : BASE_KEY;
}

// одноразовый перенос старого общего ключа в ключ текущего пользователя
export function migrateSelectionNegotiationsIfNeeded(): void {
  const email = getUserEmail();
  if (!email) return;

  const legacy = localStorage.getItem(BASE_KEY);
  if (legacy === null) return;

  const userKey = `${BASE_KEY}.${email}`;
  if (localStorage.getItem(userKey) === null) {
    localStorage.setItem(userKey, legacy);
  }
  localStorage.removeItem(BASE_KEY);
}

export function getSavedSelectionNegotiations(): Record<string, SelectionNegotiationConfig> {
  try {
    migrateSelectionNegotiationsIfNeeded();
    const raw = localStorage.getItem(getStorageKey());
    return raw ? (JSON.parse(raw) as Record<string, SelectionNegotiationConfig>) : {};
  } catch (error) {
    console.error("Failed to read selection negotiations: ", error);
    return {};
  }
}

export function saveSelectionNegotiations(map: Record<string, SelectionNegotiationConfig>): void {
  try {
    localStorage.setItem(getStorageKey(), JSON.stringify(map));
  } catch (error) {
    console.error("Failed to save selection negotiations: ", error);
  }
}
